import * as _ from 'lodash';
import moment from 'moment';
import 'moment-timezone';
import { v4 as uuid } from 'uuid';
import { SurveyDatabaseRecord } from './survey-database-record';

export class SurveyDocument extends SurveyDatabaseRecord {
    static objectStoreName = 'surveyDocument'

    id: string;
    name: string;
    type: string;
    surveyChoices: SurveyChoice[];
    surveyTemplate: SurveyTemplate[];
    version: number;

    constructor (data: {} = {}) {
      super(data);
      this.id = data['id'] || '';
      this.name = data['name'];
      this.type = data['type'];
      this.version = data['version'];
      if (_.has(data, 'survey_choices')) {
          this.surveyChoices = data['survey_choices'];
      }
      if (_.has(data, 'survey_template')) {
          this.surveyTemplate = data['survey_template'];
      }
    }

    toJSON () {
      return super.toJSON([
        'id',
        'name',
        'type',
        'version',
        'survey_choices',
        'survey_template'
      ]);
    }

    public getName(): string {
      return this.name;
    }

    public getSurveyChoices() {
        return this.surveyChoices;
    }

    public getSurveyTemplate() {
        return this.surveyTemplate;
    }
  }

  export class SurveyTemplateDocument extends SurveyDatabaseRecord {
    static objectStoreName = 'surveyTemplateDocument';

    uuid: string;
    document: SurveyDocument;
    version: number;

    constructor (data: {} = {}) {
      super(data);
      this.uuid = data['uuid'] || uuid();
      this.document = new SurveyDocument(data['document']);
      this.version = data['version'];
    }

    toJSON() {
      return super.toJSON([
        'uuid',
        'document',
        'version'
      ]);
    }
  }

  export class SurveyChoice extends SurveyDatabaseRecord {
    static objectStoreName = 'surveyChoices'

    id: string;
    label: string;
    pft_class_label: string;
    score_weight: number;

    constructor (data: {} = {}) {
      super(data)
      this.id = data['id'];
      this.label = data['label'];
      this.pft_class_label = data['pft_class_label'];
      this.score_weight = data['score_weight'] || 0;
    }

    toJSON() {
      return super.toJSON([
        'id',
        'label',
        'pft_class_label',
        'score_weight'
      ]);
    }
  }

  export class SurveyTemplate extends SurveyDatabaseRecord {
    static objectStoreName = 'surveyTemplates'

    id: string;
    category: string;
    questions: SurveyQuestion[];

    constructor (data: {} = {}) {
      super(data);
      this.id = data['id'] || '';
      this.category = data['category'];
      if (_.has(data, 'questions')) {
          this.questions = data['questions'];
      }
    }

    toJSON () {
      return super.toJSON([
        'id',
        'category',
        'questions'
      ]);
    }

    getQuestions() {
        return this.questions;
    }
  }

  export class SurveyQuestion extends SurveyDatabaseRecord {
    static objectStoreName = 'surveyQuestions'

    id: string;
    order: number;
    question: string;

    constructor (data: {} = {}) {
      super(data)
      this.id = data['id'] || ''
      this.order = data['order']
      this.question = data['question']
    }

    toJSON() {
      return super.toJSON([
        'id',
        'order',
        'question'
      ]);
    }
  }
